import { W as WuiTab$1, d as defineCustomElement$1 } from './p-CPK1giqP.js';

const WuiTab = WuiTab$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTab, defineCustomElement };
